import React from "react";
// import { useTranslation } from "react-i18next";

/**
 * 空白区域组件
 */
export const EmptyArea: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  // const { t } = useTranslation(["v3/clock"]);

  return (
    <div
      className="h-full w-full flex items-center justify-center group clock-empty-area active:opacity-35 transition duration-150 cursor-pointer hover:opacity-75"
      {...props}
    >
      <div className="flex items-center justify-center flex-col gap-1">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="opacity-75"
        >
          <circle opacity="0.1" cx="12" cy="12" r="12" fill="currentColor" />
          <path
            d="M8 12H16M12 8V16"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="opacity-35">{"添加小组件"}</span>
      </div>
    </div>
  );
};

export default EmptyArea;
